var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalndr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 17.9474H1.88889C0.845684 17.9474 0 17.1439 0 16.1527V3.58948C0 2.59828 0.845684 1.79474 1.88889 1.79474H3.77778V0H5.66667V1.79474H11.3333V0H13.2222V1.79474H15.1111C16.1543 1.79474 17 2.59828 17 3.58948V16.1527C17 17.1439 16.1543 17.9474 15.1111 17.9474ZM1.88889 7.17897V16.1527H15.1111V7.17897H1.88889ZM1.88889 3.58948V5.38423H15.1111V3.58948H1.88889ZM13.2222 14.3579H11.3333V12.5632H13.2222V14.3579ZM9.44444 14.3579H7.55556V12.5632H9.44444V14.3579ZM5.66667 14.3579H3.77778V12.5632H5.66667V14.3579ZM13.2222 10.7685H11.3333V8.97371H13.2222V10.7685ZM9.44444 10.7685H7.55556V8.97371H9.44444V10.7685ZM5.66667 10.7685H3.77778V8.97371H5.66667V10.7685Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalndr);
export default __webpack_public_path__ + "static/media/calndr.b8f4d2e1f4c2971a88347c3b977f8e2a.svg";
export { ForwardRef as ReactComponent };